import Masonry from 'masonry-layout';

export function masonrySetup() {
  if($('.masonry').length > 0){
    var grid = document.querySelector('.masonry > .row');
    return new Masonry(grid, {
      itemSelector: '.col-md-4',
      columnWidth: '.col-md-4'
    });
  }
}
